// utils
import {
  characterWalk
} from '@/assets/js/utils/characterWalk'
import {
  characterSpeech
} from '@/assets/js/utils/characterSpeech'
import {
  createBlinkAnimation
} from '@/assets/js/utils/createBlinkAnimation'
import {
  updateText
} from '@/assets/js/utils/updateText'

// character animations
import {
  reeceAnimations
} from '@/assets/js/characters/reeceAnimations'
import {
  haileyAnimations
} from '@/assets/js/characters/haileyAnimations'
import {
  devynAnimations
} from '@/assets/js/characters/devynAnimations'
import {
  riaAnimations
} from '@/assets/js/characters/riaAnimations'
import {
  ayeAnimations
} from '@/assets/js/characters/ayeAnimations'

import {
  skylarAnimations
} from './skylarAnimations'
import {
  dylanAnimations
} from './dylanAnimations'
import {
  joeAnimations
} from './joeAnimations'

import anime from 'animejs'

const reece = reeceAnimations()
const hailey = haileyAnimations()
const devyn = devynAnimations()
const ria = riaAnimations()
const aye = ayeAnimations()
const skylar = skylarAnimations()
const dylan = dylanAnimations()
const joe = joeAnimations()

const slides = []

const addSlide = (slide) => {
  slides.push(slide)
}

// audio
let schoolHallway = new Audio('static/audio/module_6/pepRallyLonger.mp3') // replaced module_3/schoolHallway with pepRally
schoolHallway.volume = 0.125
schoolHallway.loop = true
let labAudio = new Audio('static/audio/module_1/lab_background.mp3')
labAudio.volume = 0.15
labAudio.loop = true
let libraryAudio =  new Audio('static/audio/module_4/library.wav')
libraryAudio.loop = true

// camera method. todo: move later
const moveCamera = (options, context, tl) => {
  // console.log('getting ratio...')
  // console.log(context.$refs.gymBackground.clientWidth)
  // console.log(context.$refs.gymBackground.clientWidth / 1280)
  let ratio = context.$refs.gymBackground.clientWidth / 1280
  anime({
    targets: context.camera,
    value: (options.value * ratio) || 0, // 1802 is the max value. (3082 canvas - 1280 scene)
    easing: options.easing || 'easeInOutCubic',
    duration: options.duration || 1000,
    delay: options.delay || 0,
    begin: options.begin || null,
    complete: options.complete || null
  })
}


addSlide((ctx) => { // board 2

  // create blinking animation
  createBlinkAnimation('devyn')
  ctx.controlPanelActive = false
  updateText(ctx, true)

  libraryAudio.play() // play background audio 

  aye.rotate({
    flipped: true
  }).deskHands()
  devyn.rotate({
    flipped: true
  }).deskHands({
    complete() {
      ctx.controlPanelActive = true
    }
  })
})
addSlide((ctx) => { // board 3
  ctx.controlPanelActive = false
  updateText(ctx, true)
  aye.headRotate({
    flipped: true
  })
  devyn.headRotate({
    flipped: true,
    delay: 500,
    complete() {
      ctx.controlPanelActive = true
    }
  })
})
addSlide((ctx) => { // board 4
  // todo: add walking animation here.
  updateText(ctx, true, 'Devyn')
  ctx.controlPanelActive = false
  devyn.rotate().headRotate().lowerRightArm({
    complete() {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.devynData, 3)
})
addSlide((ctx) => { // board 5
  ctx.controlPanelActive = false
  updateText(ctx, true)
  ctx.ayeData = ["neutral", "yellow"]
  setTimeout(() => {
    ctx.controlPanelActive = true
  }, 1000)
})
addSlide((ctx) => { // board 6
  ctx.controlPanelActive = false
  updateText(ctx, true, 'Devyn')
  characterSpeech(ctx.devynData, 3)
  devyn.raiseRightArm({
    half: true,
    complete() {
      ctx.controlPanelActive = true
    }
  })
})
addSlide((ctx) => { // board 7
  ctx.controlPanelActive = false
  updateText(ctx, true)
  devyn.lowerRightArm()
  aye.rotate().headRotate().lowerLeftArm({
    complete() {
      ctx.controlPanelActive = true
    }
  })
})
addSlide((ctx) => { // board 8
  ctx.controlPanelActive = false
  updateText(ctx, true, 'Devyn')
  devyn.raiseRightArm({
    complete() {
      ctx.ayeData = ["smile", "green"]
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.devynData, 3)
})
addSlide((ctx) => { // board 9  
  ctx.controlPanelActive = false
  updateText(ctx, true)
  devyn.lowerRightArm()
  aye.raiseLeftArm().raiseRightArm({
    complete() {
      ctx.controlPanelActive = true
    }
  })
})
addSlide((ctx) => { // board 10
  ctx.controlPanelActive = false
  updateText(ctx, true, 'Devyn')
  aye.lowerLeftArm().lowerRightArm()
  devyn.raiseRightArm({
    complete() {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.devynData, 3)
})

// todo: adjust index conditionals to account for additional slide.

addSlide((ctx) => { // board 11 (pop-in modal)
  updateText(ctx, false)
  ctx.openModalLayer()
  ctx.modalInd += 1 // increment pop-in modal text
})

//

addSlide((ctx) => { // board 11 and 12 (a few months later...)
  libraryAudio.pause() // stop library audio
  ctx.controlPanelActive = false
  updateText(ctx, false)
  devyn.lowerRightArm()
  ctx.showBlackOverlay = true // show black overlay
  setTimeout(() => {
    ctx.controlPanelActive = true
  }, 1000)
})
addSlide((ctx) => { // board 13 / currentSlideIndex 11 (gym)

  schoolHallway.play() // play in this callback for safari.

  updateText(ctx, true)
  ctx.devynData.gym = true
  ctx.ayeAdditionalData.gym = true
  ctx.controlPanelActive = false
  aye.rotate({
    flipped: true
  }).deskHands()
  devyn.deskHands({
    complete() {
      ctx.enableTranslate = true // bump gym scene characters down
      ctx.showBlackOverlay = false // hide black overlay
      createBlinkAnimation('devyn') // re-init blinking animation for devyn
      // schoolHallway.play() // start school hallway background audio
    }
  })
  joe.rotate({ // position joe
    flipped: true
  })
  setTimeout(() => {
    ctx.controlPanelActive = true
  }, 2000)
})

addSlide((ctx) => { // boards 14-16 (joe enters)

  ctx.blackModalText.header = 'Later, back at the Lab' // set black overlay text for later
  ctx.blackModalText.subHeader = ''
  ctx.hideModalText = true

  ctx.controlPanelActive = false
  aye.wave({
    delay: 1500,
    complete() {
      aye.lowerLeftArm({
        complete() {
          aye.deskHands({
            complete() {
              // board 17
              aye.raiseLeftArm({
                delay: 650,
                half: true,
                complete() {
                  ctx.controlPanelActive = true
                }
              }).headRotate({
                delay: 650,
                flipped: true,
                complete() {
                  updateText(ctx, true)
                  moveCamera({ // move camera to show bleachers
                    value: 700,
                    duration: 4000
                  }, ctx)
                }
              })
            }
          })
        }
      })
    }
  })
  devyn.wave({
    delay: 1500,
    complete() {
      devyn.deskHands()
    }
  })
  joe.walk({
    left: ["-20%", "150%"],
    duration: 9500
  }).wave({
    delay: 500
  })
})

addSlide((ctx) => { // board 18
  ctx.controlPanelActive = false
  updateText(ctx, true, 'Devyn')
  aye.deskHands()
  devyn.lowerLeftArm({
    complete() {
      devyn.openArms({
        complete() {
          ctx.controlPanelActive = true
        }
      })
    }
  })
  characterSpeech(ctx.devynData, 3)
})
addSlide((ctx) => { // board 19 (skylar enter)
  ctx.controlPanelActive = false
  // create blinking animations
  createBlinkAnimation('skylar')
  createBlinkAnimation('dylan')

  updateText(ctx, true)
  devyn.lowerLeftArm().lowerRightArm({
    complete() {
      devyn.headRotate({
        flipped: true
      }).wave({
        delay: 1500,
        complete() {
          devyn.deskHands()
        }
      })
    }
  })

  aye.wave({
    delay: 1500,
    complete() {
      aye.deskHands()
    }
  })
  skylar.walk({
    left: ["180%", "90%"],
    duration: 5000
  }).wave({
    delay: 1000,
    complete() {
      skylar.lowerRightArm({
        complete() {
          ctx.controlPanelActive = true
        }
      })
    }
  })

})
addSlide((ctx) => { // board 20
  ctx.controlPanelActive = false
  updateText(ctx, true, 'Skylar')
  skylar.raiseRightArm({
    complete() {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.skylarData, 3)
})
addSlide((ctx) => { // board 21
  ctx.controlPanelActive = false
  updateText(ctx, true, 'Aye')
  skylar.lowerRightArm()
  aye.raiseLeftArm({
    complete() {
      ctx.controlPanelActive = true
    }
  })
})
addSlide((ctx) => { // board 22
  ctx.controlPanelActive = false
  updateText(ctx, true, 'Skylar')
  aye.lowerLeftArm()
  skylar.raiseRightArm({
    complete () {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.skylarData, 3)
})
addSlide((ctx) => { // board 23
  ctx.controlPanelActive = false
  updateText(ctx, true, 'Devyn')
  skylar.lowerRightArm()
  devyn.handsToFace({
    complete () {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.devynData, 3)
})
addSlide((ctx) => { // board 24
  ctx.controlPanelActive = false
  updateText(ctx, true, 'Skylar')
  devyn.deskHands()
  skylar.raiseRightArm({
    complete () {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.skylarData, 3)
})
addSlide((ctx) => { // board 25
  ctx.controlPanelActive = false
  updateText(ctx, true, 'Aye')
  aye.raiseLeftArm({
    complete () {
      ctx.controlPanelActive = true
    }
  })
  skylar.lowerRightArm()
})
addSlide((ctx) => { // board 26
  ctx.controlPanelActive = false
  updateText(ctx, true, 'Skylar')
  aye.deskHands()
  skylar.raiseRightArm({
    complete () {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.skylarData, 3)
})
addSlide((ctx) => { // boards 27-28
  ctx.controlPanelActive = false
  updateText(ctx, true)
  skylar.lowerRightArm({
    complete() {
      skylar.headRotate({
        delay: 1500,
        flipped: true
      })
    }
  })
  aye
    .headRotate()
    .lowerLeftArm()
    .lowerRightArm()
    .walkInPlace({
      left: ['65%', '155%'],
      duration: 6000,
      begin() {
        moveCamera({ // move camera to show dylan
          value: 1350,
          duration: 5000,
          easing: 'linear',
          complete () {
            ctx.controlPanelActive = true
          }
        }, ctx)
      }
    })
})
addSlide((ctx) => { // board 29
  ctx.controlPanelActive = false
  updateText(ctx, true)
  aye.raiseRightArm({
    half: true,
    complete () {
      ctx.controlPanelActive = true
    }
  })
})
addSlide((ctx) => { // board 30
  ctx.controlPanelActive = false
  updateText(ctx, true, 'Dylan')
  aye.lowerRightArm({
    complete() {
      aye.handShake()
      dylan.handShake({
        complete () {
          ctx.controlPanelActive = true
        }
      })
    }
  })
  characterSpeech(ctx.dylanData, 3)
})
addSlide((ctx) => { // (not in sketch file: dylan and aye start walking to quieter side of gym)
  ctx.controlPanelActive = false
  updateText(ctx, true)

  aye
    .lowerRightArm({
      complete() {
        aye.walkInPlace({
          left: ["155%", "185%"],
          duration: 4000
        })
      }
    })

  dylan
    .lowerRightArm({
      complete() {
        dylan.rotate({
          flipped: true,
          complete() {
            dylan.walk({
              left: ["177%", "207%"],
              duration: 4000,
              begin() {
                moveCamera({ // move camera to end of gym
                  value: 1805,
                  duration: 3500,
                  // easing: 'linear'
                }, ctx)
              },
              complete() {
                dylan.rotate()
                ctx.controlPanelActive = true
              }
            })
          }
        })
      }
    })

})
addSlide((ctx) => { // board 31 (what can I do for you?)
  ctx.controlPanelActive = false
  updateText(ctx, true)
  aye.raiseRightArm({
    half: true,
    complete () {
      ctx.controlPanelActive = true
    }
  })
})
addSlide((ctx) => { // board 32 (I just wanted to thank you)
  ctx.controlPanelActive = false
  updateText(ctx, true, 'Dylan')
  aye.lowerRightArm()
  dylan.raiseRightArm({
    complete () {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.dylanData, 3)
})
addSlide((ctx) => { // board 33 (for what?)
  ctx.controlPanelActive = false
  updateText(ctx, true)
  dylan.lowerRightArm()
  aye.openArms({
    complete () {
      ctx.controlPanelActive = true
    }
  })
})
addSlide((ctx) => { // board 34
  ctx.controlPanelActive = false
  updateText(ctx, true, 'Dylan')
  aye.lowerLeftArm().lowerRightArm()
  dylan.raiseLeftArm().raiseRightArm({
    quarter: true,
    complete () {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.dylanData, 3)
})
addSlide((ctx) => { // board 35
  ctx.controlPanelActive = false
  updateText(ctx, true, 'Dylan')
  dylan.raiseRightArm({
    complete () {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.dylanData, 3)
})
addSlide((ctx) => { // board 36
  ctx.controlPanelActive = false
  updateText(ctx, true)
  aye.raiseLeftArm({
    complete () {
      ctx.controlPanelActive = true
    }
  })
  dylan.lowerLeftArm().lowerRightArm()
})
addSlide((ctx) => { // board 37
  ctx.controlPanelActive = false
  updateText(ctx, true, 'Dylan')
  aye.lowerLeftArm()
  dylan.raiseRightArm({
    half: true,
    complete () {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.dylanData, 3)
})
addSlide((ctx) => { // board 38
  ctx.controlPanelActive = false
  updateText(ctx, true)
  aye.raiseLeftArm({
    half: true,
    complete () {
      ctx.controlPanelActive = true
    }
  })
  dylan.lowerRightArm()
})
addSlide((ctx) => { // board 39
  ctx.controlPanelActive = false
  updateText(ctx, true, 'Dylan')
  aye.lowerLeftArm()
  dylan.raiseRightArm({
    half: true,
    complete () {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.dylanData, 3)
})
addSlide((ctx) => { // board 40 (dylan and aye exit)
  updateText(ctx, true)
  ctx.controlPanelActive = false
  dylan.lowerRightArm({
    complete() {
      dylan.walk({
        left: ["207%", "100%"],
        duration: 7000
      })
    }
  })
  aye.walkInPlace({
    flipped: true,
    left: ["185%", "100%"],
    duration: 7000,
    complete() {
      ctx.controlPanelActive = true
    }
  })
})
addSlide((ctx) => { // board 42 (currentSlideIndex 36, lab scene starts)
  schoolHallway.pause() // stop school hallway audio
  labAudio.play() // play lab audio here for safari
  ctx.showBlackOverlay = true
  ctx.controlPanelActive = false
  setTimeout(() => {
    moveCamera({ // reset camera to 0
      value: 0,
      duration: 1,
      easing: 'linear'
    }, ctx)
    ctx.hideModalText = false
    ctx.ayeAdditionalData.gym = false
    ctx.ayeAdditionalData.lab = true
    aye.walkInPlace({ // reposition aye
      left: ['21.25%', '21.25%'],
      duration: 1,
      complete() {
        setTimeout(() => {
          ctx.showBlackOverlay = false
          ctx.controlPanelActive = true
        }, 1000)
        // labAudio.play() // start lab audio
        ctx.enableTranslate = false // bump gym scene characters back up
      }
    })
  }, 1500)
  updateText(ctx, false, null, '...')
})
addSlide((ctx) => { // board 43 (welcome back, aye)
  ctx.showBlackOverlay = false
  ria.walkInPlace({
    flipped: true,
    left: ['100%', '60%'],
    duration: 3000,
    complete() {
      ria.raiseLeftArm({
        half: true
      })
      characterSpeech(ctx.riaData, 3)
      updateText(ctx, true)
      ctx.controlPanelActive = true
    }
  })
})
addSlide((ctx) => { // board 44
  ctx.controlPanelActive = false
  updateText(ctx, true)
  ria.lowerLeftArm()
  aye.raiseRightArm({
    complete () {
      ctx.controlPanelActive = true
    }
  })
})
addSlide((ctx) => { // board 45
  ctx.controlPanelActive = false
  updateText(ctx, true)
  aye.lowerRightArm()
  ria.raiseLeftArm({
    half: true
  }).raiseRightArm({
    half: true,
    complete () {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.riaData, 3)
})
addSlide((ctx) => { // board 46
  ctx.controlPanelActive = false
  updateText(ctx, true)
  ria.lowerLeftArm().lowerRightArm()
  aye.raiseLeftArm({
    quarter: true,
    complete () {
      ctx.controlPanelActive = true
    }
  }).raiseRightArm()
})
addSlide((ctx) => { // board 47
  ctx.controlPanelActive = false
  updateText(ctx, true)
  aye.lowerLeftArm().lowerRightArm()
  ria.touchChin().raiseRightArm({
    quarter: true,
    complete () {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.riaData, 3)
})
addSlide((ctx) => { // board 48
  ctx.controlPanelActive = false
  updateText(ctx, true)
  aye.raiseRightArm({
    complete () {
      ctx.controlPanelActive = true
    }
  })
})
addSlide((ctx) => { // board 49
  ctx.controlPanelActive = false
  updateText(ctx, true)
  aye.lowerRightArm()
  ria.lowerLeftArm({
    complete() {
      ria.raiseLeftArm()
    }
  }).lowerRightArm({
    complete() {
      ria.raiseRightArm({
        quarter: true,
        complete () {
          ctx.controlPanelActive = true
        }
      })
    }
  })
  characterSpeech(ctx.riaData, 3)
})
addSlide((ctx) => { // board 50
  ctx.controlPanelActive = false
  updateText(ctx, true)
  ria.lowerLeftArm({
      complete() {
        ria.touchChin({
          delay: 750
        })
      }
    })
    .lowerRightArm({
      complete() {
        ria.raiseRightArm({
          delay: 750,
          quarter: true,
          complete () {
            ctx.controlPanelActive = true
          }
        })
      }
    })
  aye.raiseLeftArm({
    quarter: true
  }).raiseRightArm()
})
addSlide((ctx) => { // board 51
  ctx.controlPanelActive = false
  updateText(ctx, true)
  aye.lowerLeftArm().lowerRightArm()
  ria.lowerLeftArm({
    complete() {
      ria.raiseLeftArm({
        half: true
      })
    }
  }).lowerRightArm({
    complete() {
      ria.raiseRightArm({
        half: true,
        complete () {
          ctx.controlPanelActive = true
        }
      })
    }
  })
  characterSpeech(ctx.riaData, 3)
})
addSlide((ctx) => { // board 52
  ctx.controlPanelActive = false
  updateText(ctx, true)
  ria.lowerLeftArm().lowerRightArm()
  aye.raiseRightArm({
    complete () {
      ctx.controlPanelActive = true
    }
  })
})
addSlide((ctx) => { // board 53
  ctx.controlPanelActive = false
  updateText(ctx, true)
  aye.lowerRightArm()
  ria.raiseLeftArm({
    half: true
  }).raiseRightArm({
    half: true,
    complete () {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.riaData, 3)
})
addSlide((ctx) => { // board 54
  ctx.controlPanelActive = false
  updateText(ctx, true)
  ria.lowerLeftArm().lowerRightArm()
  aye.raiseLeftArm({
    quarter: true
  }).raiseRightArm({
    complete () {
      ctx.controlPanelActive = true
    }
  })
})
addSlide((ctx) => { // board 55
  ctx.controlPanelActive = false
  updateText(ctx, true)
  aye.lowerLeftArm().lowerRightArm()
  ria.raiseLeftArm({
    half: true,
    complete () {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.riaData, 3)
})
addSlide((ctx) => { // board 56
  ctx.controlPanelActive = false
  updateText(ctx, true)
  ria.lowerLeftArm()
  aye.raiseLeftArm({
    quarter: true,
    complete () {
      ctx.controlPanelActive = true
    }
  })
})
addSlide((ctx) => { // board 57
  ctx.controlPanelActive = false
  updateText(ctx, true)
  aye.lowerLeftArm()
  ria.walkInPlace({
    flipped: true,
    left: ['60%', '40%'],
    duration: 1500,
    complete() {
      ria.raiseLeftArm({
        half: true,
        complete () {
          ctx.controlPanelActive = true
        }
      })
    }
  })
  characterSpeech(ctx.riaData, 3)
})

addSlide((ctx) => {
  ctx.controlPanelActive = false
  updateText(ctx, false)
})


export {
  slides
}



// WEBPACK FOOTER //
// ./src/components/module_6/js/slidesModuleSix.js